import { Formik } from "formik"
import { Logo } from "../../common/logo/logo"
import { GlobalStyle, Container } from "../../common/styles/global-style"
import { urlsPages } from "../../common/urls/urls-pages"
import { FormSignin, ResetPassword, Register } from "./style"
import { loginState } from "./signin.state"
import { useState } from "react"
import { LoginUseCase } from "./application/usecases/login.usecase"
import { LoginModel } from "./application/domain/login"
import { ButtonPrimary, DescriptionBody, InputTextFormik, TitleBody } from "../../common"

export const Signin = () => {
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (values: LoginModel) => {
    setLoading(true);
    await LoginUseCase.login(values);
    setLoading(false);
  }

  return (
    <>
      <GlobalStyle />
      <Container>
        <Logo center={true} margintop="80px" />
        <Formik
          initialValues={loginState}
          onSubmit={(values) => handleSubmit(values)}
        >
          <FormSignin>
            <TitleBody >Acessar conta</TitleBody>
            <DescriptionBody margintop="5px" marginbottom="20px">
                Digite seus dados para acessar sua conta.
              </DescriptionBody>
            <InputTextFormik name="email" type="email" placeholder="Email" required />
            <InputTextFormik name="password" type="password" placeholder="Senha" required />
            <ButtonPrimary width="100%" margintop="0" marginbottom="30px" loading={loading}>
              Entrar
            </ButtonPrimary>
            <ResetPassword>Esqueceu sua senha?</ResetPassword>
            <Register href={urlsPages.signup}>Criar conta</Register>
          </FormSignin>
        </Formik>
      </Container>
    </>
  )
}